<template>
  <div>
    <ElRow type="flex" style="border-bottom: 2px solid lightgrey;">
      <ElCol :span="24">
        <h1>{{ $route.name }}</h1>
      </ElCol>
    </ElRow>

    <ElDialog :title="action" :visible.sync="dialogVisible">
      <ElForm ref="form" :model="form">
        <ElRow v-for="c in reply.fields" :key="c">
          <ElFormItem v-if="c != 'uuid'" :label="c" :key="c">
            <textarea
              v-if="c === 'intro'"
              :label="c"
              :key="c"
              rows="10"
              v-model="form[c]"
            />
            <ElInput v-else v-model="form[c]" />
          </ElFormItem>
        </ElRow>
      </ElForm>

      <span slot="footer" class="dialog-footer">
        <ElButton @click="dialogVisible = false" icon="el-icon-error">
          Cancel
        </ElButton>
        <ElButton type="primary" @click="save" icon="el-icon-success">
          {{ buttonText }}
        </ElButton>
      </span>
    </ElDialog>

    <br />
    <ElRow>
      <ElCol :span="4">
        <input
          @change="filterMaar"
          v-model="filterOn"
          placeholder="Text to search..."
          type="text"
          lazy
          size="30"
        />
      </ElCol>
      <ElCol :span="8">
        &nbsp;
        <ElButton type="primary" @click="filterMaar" icon="el-icon-search">
          Search
        </ElButton>
        <ElButton type="primary" @click="reload" icon="el-icon-refresh">
          Reload
        </ElButton>

        <ElButton type="primary" @click="add" icon="el-icon-plus">
          Add
        </ElButton>
      </ElCol>
      <ElCol :span="12">
        <ElAlert
          v-if="filterMsg"
          :closable="false"
          title=""
          :type="filterMsgType"
        >
          <strong>{{ filterMsg }}</strong>
        </ElAlert>
      </ElCol>
    </ElRow>
    <ElRow
      ><ElCol>
        <b>{{ reply.count }}</b> entries</ElCol
      ></ElRow
    >

    <!--el-table :data="reply.records.data" stripe-->
    <ElTable v-if="data && data.records" :data="data.records.data" stripe>
      <!-- deze col was conditioneel via verouderde constructie: v-if="c!='uuid' && c!='intro'"  -->
      <!-- change intro computed element skipping these values -->
      <ElTableColumn
        v-for="c in reply.fields"
        :key="c"
        :prop="c"
        :label="c"
        sortable
      >
        <template slot-scope="scope">
          <img v-if="c == 'icon'" :src="scope.row.icon" />
          <span v-else>
            {{ scope.row[c] }}
          </span>
        </template>
      </ElTableColumn>

      <ElTableColumn width="240" label="operations">
        <template slot-scope="scope">
          <ElButton
            v-for="(a, i) in reply.actions"
            size="mini"
            :key="i"
            @click="handleButton(a, scope.$index, scope.row)"
            :type="a.type"
          >
            {{ a.label }}
          </ElButton>
        </template>
      </ElTableColumn>
    </ElTable>

    <ElRow v-if="reply.relations && reply.relations.length">
      <h4 class="admin">
        Relations
      </h4>
      <ElCol :span="24">
        <ElTag
          :hit="true"
          style="margin-right:1em"
          :key="i"
          v-for="(r, i) in reply.relations"
        >
          {{ r }}
        </ElTag>
      </ElCol>
    </ElRow>
    <ElRow v-if="reply.types && reply.types.length">
      <h4 class="admin">
        Relation Types
      </h4>
      <ElCol :span="24">
        <ElTag
          :hit="true"
          style="margin-right:1em"
          :key="i"
          v-for="(r, i) in reply.types"
        >
          {{ r }}
        </ElTag>
      </ElCol>
    </ElRow>
  </div>
</template>
<script>
import { API } from "@/tic"
export default {
  name: "GenericAdmin",

  beforeRouteEnter(to, from, next) {
    // load new data on route change
    next(vm => {
      vm.filterOn = ""
      vm.loadData()
    })
  },

  watch: {
    set: {
      immediate: true,
      handler: "loadData"
    }
  },

  methods: {
    reload() {
      this.filterOn = ""
      this.filterMsg = ""
      this.loadData()
    },

    filterMaar(e) {
      let re = RegExp(this.filterOn, "ig")
      this.data.records.data = this.reply.records.data.filter(e => {
        let isMatch = re.test(JSON.stringify(e))
        console.log(e.name, isMatch)
        if (isMatch) {
          return true
        }
      })

      if (this.data.records.data.length === 0) {
        this.filterMsg = "Nothing found"
        this.filterMsgType = "error"
        this.loadData()
      } else {
        this.filterMsg = `${this.data.records.data.length} matches`
        this.filterMsgType = "success"
      }
    },

    add() {
      this.dialogVisible = true
      this.buttonText = "Add"
      this.action = "Add new record"
      // initialise all fields otherwise the API does not receive
      // all the fieldnames
      for (const field of this.reply.fields) {
        this.form[field] = ""
      }
      this.meta.new = true
    },

    save(a, b, c) {
      console.log("--> SAVE ", a, b, c)
      let url = `/admin/edit/${this.form.uuid}`
      API.post(url, {
        meta: this.meta,
        form: this.form
      }).then(resp => {
        console.log("SAVE: ", resp)
        this.dialogVisible = false
        this.meta.new = false
        this.loadData()
      })
    },

    handleClose() {
      console.log("handleclose")
      return true
    },

    handleButton(action, index, row) {
      let vm = this
      console.log(`button: ${action.name} index: ${index} row: ${row}`)
      if (action.confirm) {
        this.$confirm(`${action.label} this item. Continue?`, "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        })
          .then(() => {
            // this.$message({
            //	type: 'success',
            //	message: 'Delete completed'
            // });
            console.log(
              "do the delete; session: ",
              vm.$store.getters["user/currentSession"]
            )
            vm.actions[action.name](row, vm)
          })
          .catch(e => {
            console.log("err: ", e)
            this.$message({
              type: "info",
              message: `${action.label} canceled`
            })
          })
      } else {
        vm.actions[action.name](row, vm)
      }
    },

    loadData() {
      console.log("loaddata..", this.$route.name)
      let url = `/admin/list/${this.$route.name}?key=uuid`
      API.get(url).then(resp => {
        console.log("--> GenericEditor loadData: ", resp.data)
        this.reply = resp.data
        this.data = resp.data
        if (!resp.data.fields.length) {
          this.$alert(
            `No fields detected in nodes ${this.$route.name}`,
            "Error",
            {
              confirmButtonText: "OK",
              callback: action => {
                this.$router.push({ name: "Dashboard" })
                return false
              }
            }
          )
        }
      })
    }
  },

  data() {
    return {
      data: [],
      action: "",
      buttonText: "",
      filterOn: "",
      filterMsg: "",
      filterMsgType: null,
      form: {},
      reply: {},
      dialogVisible: false,
      meta: {
        node: this.$route.name,
        new: false
      },

      // the actions in the tableview
      actions: {
        edit(rec, vm) {
          vm.action = "Edit record"
          vm.buttonText = "Update"

          console.log("edit uit actions met ", rec.uuid)
          let url = `/admin/get/${rec.uuid}`
          API.get(url).then(resp => {
            console.log("resp: ", resp)
            vm.form = resp.data.data
          })
          vm.dialogVisible = true
        },

        delete(rec, vm) {
          let url = `/admin/delete/${rec.uuid}`
          API.delete(url, {
            data: {
              session: vm.$store.getters["user/currentSession"]
            }
          }).then(resp => {
            // reload the data
            if (resp.data.isError) {
              vm.$alert(
                `Error deleting record <b>${rec.uuid}</b><br>API response: ${resp.data.errorCode}`,
                "Error",
                { dangerouslyUseHTMLString: true }
              )
            } else {
              vm.loadData()
            }
          })
        }
      }
    }
  }
}
</script>
